module.exports = __webpack_public_path__ + "img/email-arrows.68158b04.png";